import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '@algoacademy/design-system/web/overlays/Dialog';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
export function UnsavedChangesDialog(t0) {
  const $ = _c(14);
  const {
    navigationGuard
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogTitle icon={<ExclamationTriangleIcon className="h-6 w-6" />}>Niezapisane zmiany</DialogTitle>;
    t2 = <DialogDescription>Czy na pewno chcesz opuścić stronę? Wszystkie zmiany w formularzu zostaną utracone.</DialogDescription>;
    t3 = <DialogBody />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== navigationGuard.reject) {
    t4 = <Button outline={true} onClick={navigationGuard.reject}>Anuluj</Button>;
    $[3] = navigationGuard.reject;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== navigationGuard.accept) {
    t5 = <Button onClick={navigationGuard.accept} color="warning">Opuść stronę mimo to</Button>;
    $[5] = navigationGuard.accept;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <DialogActions>{t4}{t5}</DialogActions>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== navigationGuard.active || $[11] !== navigationGuard.reject || $[12] !== t6) {
    t7 = <Dialog open={navigationGuard.active} onClose={navigationGuard.reject} type="warning">{t1}{t2}{t3}{t6}</Dialog>;
    $[10] = navigationGuard.active;
    $[11] = navigationGuard.reject;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}